<template>
  <div>
    <div class="md-layout" v-if="loading">
      <div class="md-layout-item md-size-100">
        <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        {{msg_status}} ..
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Configuração</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-100">{{usuario_nome}}</div>
            </div>
            <div class="md-layout">
              <label class="md-layout-item md-size-20 md-xsmall-size-30 md-form-label">Qtde Registros por Página:</label>
              <div class="md-layout-item md-size-70 md-xsmall-size-70">
                <md-field>
                  <md-select
                    v-if="items_qtde != null && items_qtde.length > 0 "
                    v-model="form.qtde_paginas"
                    name="qtde_paginas"
                    id="qtde_paginas"
                  >
                    <md-option
                      v-for="(item,index) in items_qtde"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
            <div class="md-layout-item md-size-100">
              <div class="btn-right">
                <md-button
                  class="md-info"
                  type="button"
                  v-bind:disabled="loading"
                  v-on:click="salvar"
                >Salvar</md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../../services/UsuarioService";
import mixin_user from "../../../library/mixin/user";
import Alerta from "../../../library/Alerta";

export default {
  mixins: [mixin_user],
  data() {
    return {
      loading: false,
      msg_status: "",
      usuario_nome: "",

      form: {
        qtde_paginas: "6"
      },
      items_qtde: [{ value: "6", label: "6" }, { value: "15", label: "15" }]
    };
  },
  mounted() {
    this.loading = true;
    this.msg_status = "Carregando..";
    this.usuario_nome = this.getGlobalUserProp("nome");
    var parametros = this.getGlobalUserProp("parametros");
    if (parametros != null) {
      var keys = Object.keys(parametros);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (parametros[key] != null) {
          this.form[key] = parametros[key];
        }
      }
    }
    this.loading = false;
  },
  methods: {
    salvar() {
      var self = this;
      this.loading = true;
      this.msg_status = "Salvando...";
      var id = this.getGlobalUserProp("id");
      service
        .save_parametros(id, { json: JSON.stringify(this.form) })
        .then(function(response) {
          var parametros = response.data.data;
          var user = self.getGlobalUser();
          user.parametros = parametros;

          window.user_qtde_paginas = self.form.qtde_paginas;

          self.setGlobalUser(user);
          self.form = parametros;
          Alerta.show(
            "Sucesso!",
            "Configuração atualizada com sucesso!",
            "success",
            null
          );
          self.loading = false;
        });
    }
  }
};
</script>